(function() {
    'use strict';
    /**
     * @namespace Holds specific functions/helpers to the Dynpack application.
     * The main purpose is to avoid code duplicity among flows.
     */
    window.App = Odigeo.extendNamespace(window.App, 'Dynpack');
    var DP = App.Dynpack;
    var buyPathsByPage = {
        roomselection: 'DYNPACK_EXPIRED_ROOMSELECTION_POPUP',
        dpresults: 'DYNPACK_EXPIRED_SEARCH_POPUP',
    };

    DP.getSearchData = function(params, page) {
        return App.Flights.getSearchData(params, page, DP.searchParamsParser);
    };

    DP.searchParamsStringify = function(params, keyParams) {
        var accSearchParams = App.Accommodations.searchParamsStringify(params);
        var flightSearchParams = App.Flights.searchParamsStringify(_.extend({}, params, accSearchParams.updatedParamObj), keyParams);

        return flightSearchParams + ';' + accSearchParams.stringifiedParams;
    };

    DP.searchParamsParser = function(p) {
        return $.extend(true, App.Flights.searchParamsParser(p), App.Accommodations.searchParamsParser(p));
    };

    var getDeeplink = function(extendedSearchParameters) {
        var searchParams = _.extend({},
            Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')),
            extendedSearchParameters
        );
        var extendKeyParams = ['segmentKey0', 'segmentKey1', 'fareItineraryKey'];

        return DP.searchParamsStringify(searchParams, _.zipObject(extendKeyParams, extendKeyParams));
    };

    DP.getBuyPath = function(page) {
        return buyPathsByPage[page] || 'UNKNOWN';
    };

    DP.getHomeBuyPath = function(isDynpackHome, isDynpackTabActive) {
        if (isDynpackHome) {
            return isDynpackTabActive ? 'DYNPACK_HOME_DYNPACK_TAB' : 'DYNPACK_HOME_FLIGHTS_TAB';
        }
        return isDynpackTabActive ? 'FLIGHTS_HOME_DYNPACK_TAB' : 'FLIGHTS_HOME_FLIGHTS_TAB';
    };

    DP.getMobileBuyPath = function() {
        var mobileBuyPath = Odigeo.Session.get('mobileBuyPath');
        Odigeo.Session.remove('mobileBuyPath');
        return mobileBuyPath || 'DYNPACK_DIRECT_URL';
    };

    DP.setMobileBuyPath = function() {
        var getHomeBuyPath = function() {
            return Odigeo.Utils.isRequestApp('dp') ? 'DYNPACK_MOBILE_HOME' : 'DYNPACK_MOBILE_FLIGHTS_TAB';
        };
        var buyPathsByMobilePage = {
            '': getHomeBuyPath(),
            'home': getHomeBuyPath(),
            'dpresults_flights': 'DYNPACK_MOBILE_RESULTS_CHANGE_SEARCH',
            'dpresults_accommodation': 'DYNPACK_MOBILE_ACCOMMODATION_CHANGE_SEARCH',
            'booking': 'DYNPACK_MOBILE_BOOKING_CHANGE_SEARCH',
        };

        var pageName = Odigeo.History.getPageNameFromFragment();
        var mobileBuyPath = buyPathsByMobilePage[pageName] || '';
        Odigeo.Session.set('mobileBuyPath', mobileBuyPath);
        return mobileBuyPath;
    };

    DP.getDeeplinkWithPreselected = function(preselected) {
        return getDeeplink({
            dedupId: preselected.accommodation.dedupId,
            providerHotelId: preselected.accommodation.providerHotelId,
            providerId: preselected.accommodation.providerId,
            fareItineraryKey: preselected.fareItinerary.id,
            segmentKey0: preselected.fareItinerary.outboundFlight,
            segmentKey1: preselected.fareItinerary.returnFlight,
        });
    };

    DP.getDeeplinkWithoutPreselected = getDeeplink;

    DP.getPath = function(options) {
        return Odigeo.Utils.templateLiteral('${protocol}//${host}${path}/dp/${pageParams}#${page}/${searchParams}', {
            protocol: window.location.protocol,
            host: window.location.hostname,
            path: Odigeo.Settings.getProperty('appContext'),
            pageParams: _.isString(options.pageParams) ? '?' + options.pageParams : '',
            page: options.page || Odigeo.History.getPageNameFromFragment(),
            searchParams: options.searchParams,
        });
    };

    DP.getLabelTrackRooms = function(searchParams) {
        return _.reduce(searchParams.rooms, function(label, room, index) {
            return label += '_num:' + (index + 1) +
                '_adu:' + room['numAdults'] +
                '_child:' + _.size(room['kidsAges']) +
                '_baby:' + _.size(room['infantsAges']);
        }, 'rooms:' + searchParams.numberOfRooms);
    };
}());
